<template>
    <table>
        <tr v-for="(el, index) in elements" :key="index">
            <td>{{ el.label }}</td>
            <td class="check-frame">
                <input type="checkbox" v-model="datas[el._id]" :disabled="disabled">
            </td>
        </tr>
    </table>
</template>

<script>

export default {
    emits: ['closed'],
    props: ['elements', 'values', 'disabled'],
    data() {
        return {
            datas: {},
            mounted: false,
        }
    },
    watch: {
        values: {
            deep: true,
            handler() {
                if (this.values) {
                    Object.keys(this.datas).forEach(id => {
                        if (this.values.includes(id)) {
                            this.datas[id] = true;
                        }
                    });
                }
            }
        },
        datas: {
            deep: true,
            handler() {
                if (this.mounted) {
                    const result = [];

                    Object.keys(this.datas).forEach(id => {
                        if (this.datas[id]) {
                            result.push(id);
                        }
                    });

                    this.$emit('closed', result);
                }
            }
        }
    },
    mounted() {
        this.elements.forEach(el => {
            this.datas[el._id] = false;
        })

        if (this.values) {
            Object.keys(this.datas).forEach(id => {
                if (this.values.includes(id)) {
                    this.datas[id] = true;
                }
            });
        }

        this.mounted = true;
    }
}
</script>

<style scoped>
table {
    width: 100%;
    border-bottom: solid 1px rgb(251, 248, 248);
    margin-bottom: 10px;
}

td {
    width: 50%;
    padding: 0 10px;
}

.check-frame {
    text-align: center;
}
</style>